import React from 'react';

const Delete = ({ svgRef, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" ref={svgRef} {...props}>
    <g>
      <g>
        <g>
          <path fill="#ff5d58" d="M0 15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"/>
        </g>
        <g>
          <g>
            <path fill="#fff" d="M12.5 12.5h5v7h-5zM13 10v1h-3v1.5h1V21h8v-8.5h1V11h-3v-1z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Delete



// WEBPACK FOOTER //
// ./src/common/icons/Delete.js